export default __webpack_public_path__ + "static/media/camera-2.41a25b95.png";